import {
  TrendingDown,
  CalendarClock,
  ShieldPlus,
  ClipboardList,
  Target,
} from 'lucide-react'
export const bonuses = [
  {
    number: 1,
    title: 'Tracker Visual de Deudas',
    description: 'Para ver, pago a pago, cómo tus deudas desaparecen.',
    icon: TrendingDown,
  },
  {
    number: 2,
    title: 'Calendario Inteligente de Pagos',
    description: 'Para que ningún vencimiento vuelva a tomarte por sorpresa.',
    icon: CalendarClock,
  },
  {
    number: 3,
    title: 'Sistema Fondo de Emergencia',
    description: 'Para construir tu colchón financiero sin improvisar.',
    icon: ShieldPlus,
  },
  {
    number: 4,
    title: 'Planificador Financiero Mensual',
    description: 'Para decidir tus prioridades antes de que empiece el mes.',
    icon: ClipboardList,
  },
  {
    number: 5,
    title: 'Desafío 30 Días Sin Gastos Impulsivos',
    description: 'El reset mental que corta los gastos automáticos.',
    icon: Target,
  },
]
